import { useEffect, useState } from "react";

const useEditCandidateList = (interview) => {
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    if (interview) {
      if (Array.isArray(interview?.data) && interview.data.length > 0) {
        const updatedFilteredData = interview.data.filter(
          (data) => data?.status !== "Completed" && data?.status !== "Cancelled"
        );
        setFilteredData(updatedFilteredData);
        setIsLoading(false);
      } else if (interview?.data !== undefined) {
        setFilteredData([]);
        setIsLoading(false);
      }
    } else {
      setFilteredData([]);

      setIsLoading(false);
    }
  }, [interview]);

  return {
    filteredData,
    isLoading,
  };
};

export default useEditCandidateList;
